import Header from '@/components/layout/Header';
import { ROUTES } from '@/configs/constants';
import { t } from 'i18next';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const faqData = [
    {
        icon: '📝',
        title: 'サービスについて',
        items: [
            {
                question: '「omikuji」とはどんなサービスですか？',
                answer: '「omikuji」は、Web地図上に配置されたデジタルアイテムを、特定のエリアでスマホを振ることで取得できるWebアプリです。クーポンや特別なデジタルコンテンツをゲットできます。'
            },
            {
                question: 'アプリのインストールは必要ですか？',
                answer: 'いいえ、Webブラウザ上で利用できるので、アプリのダウンロードは不要です。'
            }
        ]
    },
    {
        icon: '📌',
        title: '使い方について',
        items: [
            {
                question: 'どうやってアイテムを取得できますか？',
                answer: '地図上でアイテムの位置を確認し、対象エリアに行ったらスマートフォンを振るだけで取得できます。'
            },
            {
                question: 'どんなデジタルアイテムがありますか？',
                answer: '飲食店のクーポン、観光スポットの限定フォト、イベントチケットなど、多彩なアイテムを準備しています。'
            }
        ]
    },
    {
        icon: '🌍',
        title: 'インバウンド向け',
        items: [
            {
                question: '言語対応はありますか？',
                answer: 'UIは日本に対応しており、直感的な操作で誰でも楽しめます。'
            },
            {
                question: '観光客向けの特典はありますか？',
                answer: '一部の観光地や施設では、訪日観光客向けの特別なクーポンやデジタル記念品の配布を予定しています。'
            }
        ]
    },
    {
        icon: '🔧',
        title: 'トラブルシューティング',
        items: [
            {
                question: 'アイテムを取得できません。どうすればいいですか？',
                answer: (
                    <>
                        以下の点をご確認ください。
                        <ul className='list-disc pl-5 mt-1'>
                            <li>✅ スマートフォンの位置情報がONになっているか</li>
                            <li>✅ エリア内に正しく入っているか</li>
                            <li>✅ スマートフォンをしっかり振っているか</li>
                        </ul>
                    </>
                )
            },
            {
                question: '推奨環境はありますか？',
                answer: '最新のGoogle Chrome、Safari、Firefoxでのご利用を推奨しています。'
            }
        ]
    }
];

const FAQ = () => {
    const [openIndexes, setOpenIndexes] = useState({});
    const navigate = useNavigate();
    const toggle = (sectionIndex, itemIndex) => {
        const key = `${sectionIndex}-${itemIndex}`;
        setOpenIndexes(prev => ({
            ...prev,
            [key]: !prev[key]
        }));
    };
    const goBack = () => {
        navigate(-1);
    };
    return (
        <div className='w-screen h-screen flex flex-col justify-start bg-white pt-[72px] min-h-screen pb-[env(safe-area-inset-bottom)] overflow-y-auto'>
            <Header goBackFunction={goBack} title={t('text.faq')} />
            <div className='max-w-3xl mx-auto px-4 space-y-6 pb-8'>
                {faqData.map((section, sectionIndex) => (
                    <div key={sectionIndex}>
                        <h2 className='text-xl font-bold mb-2'>
                            {section.icon}
                            {' '}
                            {section.title}
                        </h2>
                        <div className='space-y-2'>
                            {section.items.map((item, itemIndex) => {
                                const key = `${sectionIndex}-${itemIndex}`;
                                const isOpen = openIndexes[key];
                                return (
                                    <div key={itemIndex} className='border rounded-md'>
                                        <button
                                            onClick={() => toggle(sectionIndex, itemIndex)}
                                            className='w-full text-left p-3 font-medium hover:bg-gray-100'
                                        >
                                            Q.
                                            {' '}
                                            {item.question}
                                        </button>
                                        {isOpen && (
                                            <div className='px-4 py-2 bg-gray-50 text-gray-800'>
                                                A.
                                                {' '}
                                                {item.answer}
                                            </div>
                                        )}
                                    </div>
                                );
                            })}
                        </div>
                    </div>

                ))}
            </div>
        </div>
    );
};

export default FAQ;
